/** BR 请求种类（与后端 RequestKind / 前端合成卡一致） */
export const BR_REQUEST_KIND = {
  BR_DOCUMENT: 'BR_DOCUMENT',
  NAME_CHANGE: 'NAME_CHANGE',
  NAME_CHANGE_RESULT: 'NAME_CHANGE_RESULT',
};

export function getBrRequestKind(row) {
  return String(row?.requestKind || row?.RequestKind || '').toUpperCase();
}

export function isBrNameChangeRequestKind(row) {
  return getBrRequestKind(row) === BR_REQUEST_KIND.NAME_CHANGE;
}
